module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Cap-3-6160c9fd24e1a5f9bec9a072b017b32b.svg";